"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconWeatherForecast = function IconWeatherForecast(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16 5h1v4h-1zm9.866 2.5L25 7l-2 3.464.866.5zM2.212 12.695l-.5.866 3.464 2 .5-.866zM0 22v1h4v-1zM7.712 7.195l.866-.5 2 3.464-.866.5zM22.5 17a7.5 7.5 0 0 0-12.016 8.98 7.8 7.8 0 0 1 2.478-.611c.762-2.939 2.736-6.446 6.374-7.802A8.8 8.8 0 0 1 22.5 17m2.574.404A9.5 9.5 0 0 0 7 21.5c0 2.07.662 3.986 1.787 5.547-.477.41-.893.882-1.247 1.406-1.25 1.848-1.682 4.243-1.5 6.567.375 4.793 4.638 7.98 9.282 7.98h23.536c1.828 0 3.898-.743 5.59-2.03 1.702-1.295 3.105-3.207 3.451-5.61.233-1.612.1-3.772-.798-5.705-.833-1.792-2.325-3.377-4.715-4.104l-.006-.061a10 10 0 0 0-.392-1.967c-.468-1.51-1.48-3.376-3.65-4.349-2.763-1.238-5.098-.784-6.726 0a8.6 8.6 0 0 0-1.747 1.124l-.131-.124a13.5 13.5 0 0 0-2.32-1.731c-.681-.4-1.468-.772-2.34-1.039m3.99 4.943-.005-.006a4 4 0 0 0-.159-.177 11.49 11.49 0 0 0-2.498-1.996c-1.665-.977-3.88-1.654-6.368-.727-3.035 1.132-4.752 4.35-5.285 7.085l-.158.81h-.824c-2.22 0-3.672.91-4.57 2.238-.93 1.372-1.32 3.28-1.163 5.29.279 3.558 3.482 6.136 7.29 6.136-.001 0-.002 0-.002 1l.001-1h23.535c1.33 0 2.985-.56 4.379-1.621 1.383-1.053 2.427-2.532 2.683-4.304.188-1.31.07-3.064-.633-4.577-.684-1.472-1.921-2.73-4.072-3.185l-.815-.172.022-.83v-.029l-.001-.12a7.996 7.996 0 0 0-.344-2.046c-.374-1.209-1.108-2.467-2.556-3.116-2.133-.956-3.846-.6-5.042-.024a6.6 6.6 0 0 0-1.78 1.269q-.06.06-.085.09l-.016.018-.001.001-.769.917z",
    clipRule: "evenodd"
  })));
};

export { IconWeatherForecast, IconWeatherForecast as default };
